import { createSelector } from "reselect";
import { IProactiveChatState } from "./proactive-chat.types";

/**
 * Get setup data from the setup state.
 * @param state Setup state.
 * @returns     Setup data property.
 */
const selectData = (data: IProactiveChatState) => data;

/**
 * Get the translations enabled state. Not all clients will have this feature turned on.
 * @returns Translation enabled state selector.
 */
export const getIsProactiveChatEnabled = createSelector(selectData, (data) =>
    typeof data === "undefined" ? false : data.enabled
);
